import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';

import BgImg from './MLCardBgImg';

import './MLCard.scss';

const MLCard = ({ children, className, ...props }) => {
    const classNames = classnames('ml-card', className);
    return (
        <Card
            className={classNames}
            {...props}
        >
            { children }
        </Card>
    );
};

MLCard.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

MLCard.Header = Card.Header;
MLCard.Body = Card.Body;
MLCard.Footer = Card.Footer;
MLCard.Img = Card.Img;
MLCard.BgImg = BgImg;
MLCard.Text = Card.Text;
MLCard.Title = Card.Title;

export default MLCard;
